// src/store/modules/userPrefs.js

const state = {
  preferences: {
  }
}

const mutations = {
  SET_PREFERENCE(state, { key, value }) {
    state.preferences[key] = value
  },
  CLEAR_PREFERENCES(state) {
    state.preferences = {
    }
  }
}

const actions = {
  setPreference({ commit }, preference) {
    commit('SET_PREFERENCE', preference)
  },
  clearPreferences({ commit }) {
    commit('CLEAR_PREFERENCES')
  }
}

const getters = {
  getPreference: (state) => (key) => {
    return state.preferences[key]
  },
  allPreferences: (state) => state.preferences
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
